import {
	PurchaseApi,
	PurchaseCorrectionApi,
	PurchaseCorrectionItemApi,
} from "../../../../../../../../../../../../../services/Api/Organization/types";

export const getParsedPurchaseCorrectionItemsToForm = (
	corrections: PurchaseCorrectionApi[],
	purchase: PurchaseApi,
	correction?: PurchaseCorrectionApi
): PurchaseCorrectionItemApi[] => {
	const newCorrectionItem: PurchaseCorrectionItemApi = {
		id: null,
		tax: null,
		volume: null,
		tax_id: null,
		total_price_net_money: null,
		total_price_gross_money: null,
		quantity: null,
		product_id: null,
		price_net_money: null,
		price_gross_money: null,
		product: null,
	};

	if (correction) {
		return correction.items ? [...correction.items, { ...newCorrectionItem }] : [{ ...newCorrectionItem }];
	}

	if (corrections.length >= 1) {
		const previousCorrection = getPreviousCorrection(undefined, corrections);
		if (!previousCorrection) {
			return [...getItemsFromPurchase(purchase), { ...newCorrectionItem }];
		}

		return [
			...previousCorrection.items.map((item) => {
				delete item.item_quantity;
				return item;
			}),
			{ ...newCorrectionItem },
		];
	}

	return [...getItemsFromPurchase(purchase), { ...newCorrectionItem }];
};

const getItemsFromPurchase = (purchase: PurchaseApi): PurchaseCorrectionItemApi[] => {
	return purchase.items.map((item, index) => ({
		item_id: item.id,
		product: item.product,
		comment: item.comment,
		id: null,
		position: index,
		price_gross_money: item.price_gross_money,
		price_net_money: item.price_net_money,
		tax: item.tax,
		quantity: item.quantity,
		volume: item.volume,
		tax_id: item.tax_id,
		product_id: item.product_id,
		total_price_gross_money: item.total_price_gross_money,
		total_price_net_money: item.total_price_net_money,
	}));
};

export const purchaseCorrectionInclude: string = "custom_fields,tags,items,items.product,attachments";

export const getPreviousCorrection = (correctionId?: number, purchaseCorrections?: PurchaseCorrectionApi[]) => {
	if (!purchaseCorrections) return undefined;

	if (!correctionId) return purchaseCorrections[0];

	const indexOfCurrentCorrection = purchaseCorrections.findIndex(({ id }) => correctionId === id);
	if (indexOfCurrentCorrection > -1) return purchaseCorrections[indexOfCurrentCorrection + 1];
	return undefined;
};
